import React, { useContext } from "react";
import { TranslatorContext } from "../../context/Translator";
import { AnchorComponent, ButtonComponent } from "../elements";
import { ProgressBar, Form } from "react-bootstrap";
import DownloadIcon from "@mui/icons-material/Download";
import { SidebarContext } from "../../context/Sidebar";
import axios from "axios";
import SearchIcon from "@mui/icons-material/Search";

export default function RescueTableComponent({
  thead,
  tbody,
  roleId,
  donors,
  onChangeRole,
  searchQuery,
  onSearch,
  onSearchClick,
}) {
  const { t } = useContext(TranslatorContext);
  const { hasPermission } = useContext(SidebarContext);

  // ✅ DOWNLOAD PDF
  const downloadPdf = async (personId) => {
    try {
      const personData = await axios.get(
        `${process.env.REACT_APP_API_URL}/family-short-pdf/${personId}`
      );
      const win = window.open(personData.data.pdf, "_blank");
      if (win) win.focus();
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <div className="mc-table-responsive">
      
      {/* 🔍 SEARCH */}
      <div
        style={{
          width: "100%",
          marginBottom: "15px",
          position: "relative",
        }}
      >
        <input
          type="text"
          placeholder={t("Search By FSF-ID , CNIC, Beneficiary Name")}
          value={searchQuery}
          onChange={(e) => onSearch(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              onSearchClick(); // ✅ ENTER KEY SEARCH
            }
          }}
          style={{
            width: "100%",
            padding: "10px 45px 10px 15px",
            borderRadius: "8px",
            border: "1px solid #ccc",
            boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
            fontSize: "16px",
          }}
        />

        {/* ✅ CLICKABLE SEARCH ICON */}
        <SearchIcon
          onClick={onSearchClick}
          style={{
            position: "absolute",
            right: "12px",
            top: "50%",
            transform: "translateY(-50%)",
            color: "#077834",
            cursor: "pointer",
          }}
        />
      </div>

      {/* 📊 TABLE */}
      <div className="table-container-responsive">
        <div className="table-scrollable">
          <table className="mc-table product">
            
            {/* HEADER */}
            <thead
              className="mc-table-head table-header"
              style={{ backgroundColor: "#077834", color: "#fff" }}
            >
              <tr>
                <th>FSF-ID</th>
                {thead.map((item, index) => (
                  <th key={index}>{t(item)}</th>
                ))}
              </tr>
            </thead>

            {/* BODY */}
            <tbody className="mc-table-body table-body">
              {tbody.length > 0 ? (
                tbody.map((item, index) => (
                  <tr key={index}>
                    
                    {/* FSF ID */}
                    <td>{item.fsf_id}</td>

                    {/* BENEFICIARY */}
                    <td>
                      <p>{item.beneficiary_name}</p>
                      <small>{item.beneficiary_cnic}</small>
                    </td>

                    {/* DONOR (ROLE 3) */}
                    {roleId === 3 && (
                      <td>
                        <Form.Select
                          value={item.sub_donor_id || ""}
                          onChange={(e) => onChangeRole(e, item.id)}
                        >
                          <option value="">Select Donor</option>
                          {donors?.map((donor) => (
                            <option key={donor.id} value={donor.id}>
                              {donor.name}
                            </option>
                          ))}
                        </Form.Select>
                      </td>
                    )}

                    {/* PARTNER */}
                    <td>
                      <p>{item.partner_name}</p>
                      <small>{item.organization_church}</small>
                    </td>

                    {/* VERIFIED */}
                    <td>{item.verified_by}</td>

                    {/* DATE */}
                    <td>
                      {item.rescue_date
                        ? new Date(item.rescue_date).toLocaleDateString()
                        : ""}
                    </td>

                    {/* STATUS */}
                    <td>{item.stage}</td>

                    {/* PROGRESS */}
                    <td>
                      <ProgressBar variant="success" now={item.progress} />
                      <p className="text-center mb-0">{item.progress}%</p>
                    </td>

                    {/* ACTIONS */}
                    <td>
                      <div className="mc-table-action">
                        
                        {/* VIEW */}
                        <AnchorComponent
                          to={`/family-report/${item.fsf_id}`}
                          className="material-icons"
                        >
                          visibility
                        </AnchorComponent>

                        {/* EDIT */}
                        {hasPermission("CanEditRescue") && (
                          <AnchorComponent
                            to={`/family-rescue-form/${item.id}`}
                            className="material-icons"
                          >
                            edit
                          </AnchorComponent>
                        )}

                        {/* DOWNLOAD */}
                        <ButtonComponent onClick={() => downloadPdf(item.id)}>
                          <DownloadIcon fontSize="small" />
                        </ButtonComponent>
                      </div>
                    </td>
                  </tr>
                ))
              ) : (
                // ✅ NO DATA STATE
                <tr>
                  <td colSpan={thead.length + 2} className="text-center p-4">
                    No data found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}